export default "__VITE_ASSET__CUAiWV5c__"